<ng-container>
  <div class="transaction-list-details__index-list">
    <!--the added and removed list are only shown when needed inside rebalancing transactions-->
    @if (hasTrades(getAddedTrades())) {
      <div class="font-size-15 large-weight pb-10 pt-15 text-capitalize">
        {{ "rebalance_tx_added" | translate }}
      </div>
      @for (transaction of getAddedTrades$() | async; track transaction) {
        <tradable-transaction-list-item
          class="pb-10"
          [transaction]="transaction"
          [showShareButton]="showShareButton"
          [isInnerIndexTransaction]="true"
          [activity]="'history'"
          [focusable]="true">
        </tradable-transaction-list-item>
      }
    }
    @if (hasTrades(getRemovedTrades())) {
      <div class="font-size-15 large-weight pb-10 pt-15 text-capitalize">
        {{ "rebalance_tx_removed" | translate }}
      </div>
      @for (transaction of getRemovedTrades$() | async; track transaction) {
        <tradable-transaction-list-item
          class="pb-10"
          [transaction]="transaction"
          [showShareButton]="showShareButton"
          [isInnerIndexTransaction]="true"
          [activity]="'history'"
          [focusable]="true">
        </tradable-transaction-list-item>
      }
    }
    <!--rebalancing list is used for normal index trades and the fiat index view-->
    @if (hasTrades(getRebalanceTrades())) {
      @if (isRebalancingTx()) {
        <div class="font-size-15 large-weight pb-10 pt-15 text-capitalize">
          {{ "rebalance_tx_rebalanced" | translate }}
        </div>
      }
      @for (transaction of getRebalanceTrades$() | async; track transaction) {
        @if (showFiatTxList()) {
          <fiat-transaction-list-item
            [balance]="balance$ | async"
            class="pb-10"
            [transaction]="transaction"
            [showShareButton]="showShareButton"
            [activity]="'history'"
            [focusable]="true">
          </fiat-transaction-list-item>
        } @else {
          <tradable-transaction-list-item
            class="pb-10"
            [transaction]="transaction"
            [showShareButton]="showShareButton"
            [isInnerIndexTransaction]="true"
            [activity]="'history'"
            [focusable]="true">
          </tradable-transaction-list-item>
        }
      }
    }
  </div>
</ng-container>
